import React, { useContext } from 'react';
import { useRouter } from 'next/router';

import { ThemeContext } from 'components/publicWebsiteV2/context';
import { Container, Text } from './Banner.styles';

const Banner = (): JSX.Element | null => {
  const router = useRouter();
  const { preview_type } = router?.query || {}; // if preview_type exists, hide banner

  const {
    wedding,
    components: { globalHeaderFontValues, backgroundColors },
    inPreview,
  } = useContext(ThemeContext);
  const { public_theme_v2 } = wedding || {};
  const navHeaderFontColor =
    public_theme_v2?.components?.NAV?.fonts?.HEADER?.[1].color || globalHeaderFontValues.color;
  const { enable_cms_banner: bannerCMSEnabled, cms_banner_message: bannerText } = wedding || {};

  if (!bannerCMSEnabled || preview_type || inPreview) return null;

  return (
    <Container backgroundColor={navHeaderFontColor} fontColor={backgroundColors.nav}>
      <Text>{bannerText}</Text>
    </Container>
  );
};

export default Banner;
